import React from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import { employerProfileIndexUrl } from 'buyside/util/urlHelper';

const FundDisclaimerModal = ({ acceptFundDisclaimer }) => (
  <Modal isOpen onClose={() => (window.location = employerProfileIndexUrl())} title="Disclaimer">
    <p>
      <strong>Please accept the following disclaimer:</strong>
    </p>
    <div>
      The information presented in this profile has been prepared solely for informational purposes
      and does not constitute an offer to sell or a solicitation of an offer to buy interests or any
      other securities or to participate in any trading strategy.
    </div>
    <br />
    <div>
      <Button onClick={acceptFundDisclaimer} text="Accept" type={BUTTON_TYPES.PRIMARY} />
      <Button onClick={() => (window.location = employerProfileIndexUrl())} text="Decline" />
    </div>
  </Modal>
);

export default FundDisclaimerModal;
